import { Text, ToastAlertTypes, HStack, Stack } from '@genial/components';
import { Color, Spacing, Typography } from '@genial/design-tokens';

import { ModalSelectedItems } from '../../store/ProducManagement/atom';
import { ProductsManagementDetailsResponse } from '../../store/ProducManagement/types';
import { PlatformList } from '../ProductsManagement/components/ProductsManagementBlockModal/constants';

export type BlockedResourceItem = {
  key: string;
  value: string | string[];
}[];

export type BlockedResource = {
  id: number;
  canDelete?: boolean;
  item: BlockedResourceItem;
};

export enum TabKeys {
  partners = 1,
  advisors = 2,
  customers = 3,
}

export const defaultErrorMessageRequestItem: [ToastAlertTypes.Type, string, string] = [
  'error',
  'Opa! Algo parece errado.',
  'Ocorreu um erro ao realizar a solicitação.',
];

export const defaultSuccessDeleteMessageRequestItem: [ToastAlertTypes.Type, string, string] = [
  'success',
  'Tudo certo!',
  'Bloqueio removido com sucesso!',
];

export const formatResponseDataPerTab = (data: ProductsManagementDetailsResponse[] | undefined) => {
  const partnersTab: BlockedResource[] = [];
  const advisorsTab: BlockedResource[] = [];
  const customersTab: BlockedResource[] = [];

  if (!data || data.length === 0) {
    return { partners: [], advisors: [], customers: [] };
  }

  data.forEach((item) => {
    switch (item.destinationProductFilterId) {
      case TabKeys.partners:
        partnersTab.push({
          id: item.informationProductFilterId,
          canDelete: item.canDelete || false,
          item: [
            { key: 'Parceiro', value: item.branchName || '' },
            { key: 'Plataforma bloqueada', value: item.platform || '' },
            ...(item.productsList
              ? [
                  {
                    key: 'Produtos bloqueados',
                    value: item.productsList.map((product) => product.productName),
                  },
                ]
              : []),
          ],
        });
        break;
      case TabKeys.advisors:
        advisorsTab.push({
          id: item.informationProductFilterId,
          canDelete: item.canDelete || false,
          item: [
            { key: 'Assessor', value: item.advisorName || '' },
            { key: 'Plataforma bloqueada', value: item.platform || '' },
            ...(item.productsList
              ? [
                  {
                    key: 'Produtos bloqueados',
                    value: item.productsList.map((product) => product.productName),
                  },
                ]
              : []),
          ],
        });
        break;
      case TabKeys.customers:
        customersTab.push({
          id: item.informationProductFilterId,
          canDelete: item.canDelete || false,
          item: [
            { key: 'Cliente', value: item.clientName || '' },
            { key: 'Plataforma bloqueada', value: item.platform || '' },
            ...(item.productsList
              ? [
                  {
                    key: 'Produtos bloqueados',
                    value: item.productsList.map((product) => product.productName),
                  },
                ]
              : []),
          ],
        });
        break;
    }
  });

  return {
    partners: partnersTab,
    advisors: advisorsTab,
    customers: customersTab,
  };
};

export const DeleteBlockModelContent = () => (
  <>
    <Text
      variant="semibold"
      color={Color['brand.primary.darkest']}
      fontSize={Typography['fontsize.lg']}>
      Remover bloqueio ?
    </Text>
    <Text
      color={Color['brand.primary.darkest']}
      variant="regular"
      fontSize={Typography['fontsize.md']}>
      Certeza que deseja remover o bloqueio do item selecionado?
    </Text>
  </>
);

export const CreateBlockModelContent = (modalSelectedItems: ModalSelectedItems) => {
  return (
    <Stack
      w="full"
      space={Spacing['stack.quarck']}
      justifyContent="flex-start"
      px={Spacing['inline.xxs']}
      my={Spacing['stack.xxxs']}>
      <Text
        variant="semibold"
        color={Color['brand.primary.darkest']}
        fontSize={Typography['fontsize.lg']}
        my="stack.nano">
        Confirma a inclusão de um novo BLOQUEIO para os itens selecionados?
      </Text>
      <HStack alignItems="center" space={Spacing['stack.quarck']}>
        <Text
          variant="semibold"
          color={Color['brand.primary.darkest']}
          fontSize={Typography['fontsize.md']}>
          TIPO DE BLOQUEIO:
        </Text>
        <Text
          color={Color['brand.primary.darkest']}
          variant="regular"
          fontSize={Typography['fontsize.md']}>
          {modalSelectedItems.isClientOrAdvisor === 'client' && 'CLIENTE'}
          {modalSelectedItems.isClientOrAdvisor === 'advisor' && 'ASSESSOR'}
          {!modalSelectedItems.isClientOrAdvisor && 'PARCEIRO'}
        </Text>
      </HStack>

      {modalSelectedItems.isClientOrAdvisor && (
        <HStack alignItems="center" space={Spacing['stack.quarck']}>
          <Text
            variant="semibold"
            color={Color['brand.primary.darkest']}
            fontSize={Typography['fontsize.md']}>
            {modalSelectedItems.isClientOrAdvisor === 'client' ? 'CLIENTE' : 'ASSESSOR'}:
          </Text>
          <Text
            color={Color['brand.primary.darkest']}
            variant="regular"
            fontSize={Typography['fontsize.md']}>
            {modalSelectedItems.clientOrAdvisorNameId?.name.toUpperCase()}
          </Text>
        </HStack>
      )}

      <HStack alignItems="center" space={Spacing['stack.quarck']}>
        <Text
          variant="semibold"
          color={Color['brand.primary.darkest']}
          fontSize={Typography['fontsize.md']}>
          PLATAFORMA:
        </Text>
        <Text
          color={Color['brand.primary.darkest']}
          variant="regular"
          fontSize={Typography['fontsize.md']}>
          {PlatformList.filter(
            (item) => Number(item.value) === modalSelectedItems.platformId
          )[0]?.label.toUpperCase()}
        </Text>
      </HStack>

      {modalSelectedItems.productList && modalSelectedItems.productList.length > 0 && (
        <HStack alignItems="center" space={Spacing['stack.quarck']}>
          <Text
            variant="semibold"
            color={Color['brand.primary.darkest']}
            fontSize={Typography['fontsize.md']}>
            Produtos:
          </Text>
          <Text
            color={Color['brand.primary.darkest']}
            variant="regular"
            fontSize={Typography['fontsize.md']}>
            {modalSelectedItems.productList
              .map((product) => product.name)
              .join(', ')
              .toUpperCase()}
          </Text>
        </HStack>
      )}
    </Stack>
  );
};
